import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Footer from "../../../components/dashboard/footer";
import Header from "../../../components/dashboard/header";
// import Sidebar from "../../../components/dashboard/sidebar";
import SideMenu from "../../student/SideMenu";
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import Upcomingquiz from "./upcomingquiz";
import Compeletedquiz from "./completedquiz";
import CPCForm from "./cpcForm";
import ActiveResult from "./activeResult";
import tmdbApi from "../../../api/tmdbApi";
import SessionPopup from "../../SessionPopup"
const Cpcmanagement = () => {
    const [activeTab, setActiveTab] = useState(localStorage.getItem("completedTab") === "yes" ? "completed" : localStorage.getItem("completedTab") === "no" ? "activeresult" :"cpc");
    const [cpcInfoRes, setCpcInfo] = useState([]);
    const [announce, setAnnounce] = useState(null);
    const [activePage, navigatePage] = useState(null);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [completed, setCompleted] = useState(true);
    // came back from a completed CPC's detail page -> Completed tab restores its saved page (until another tab is picked)
    const [restoreCompletedPage, setRestoreCompletedPage] = useState(localStorage.getItem("completedTab") === "yes");
    const selectTab = (tab) => {
        setRestoreCompletedPage(false);
        setActiveTab(tab);
    };
    const navigate = useNavigate();
    useEffect(() => {
        getCpcInfo();
        localStorage.setItem("completedTab", "no")
    }, []);
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
            navigate("/")
        }else{
            const userType = localStorage.getItem("userType");
            if(userType === "DOCTOR"){
                 navigate("/")
            }
        }
    }, []);

    console.log('announce',announce)
    console.log('activetab',activeTab)
    console.log('activePage',activePage)
    useEffect(() => {
        if (announce) {

            setActiveTab("activeresult")
            getCpcInfo()
        }
    }, [announce]);

    useEffect(() => {
        if (activePage != null) {
            setActiveTab(activePage)
        }
    }, [activePage]);
    // useEffect(()=>{
    //     if(!cpcInfoRes?.cpcid){
    //         setActiveTab("upcoming")
    //     }else if (cpcInfoRes?.cpcid){
    //         setActiveTab("cpc")
    //     }

    // },[cpcInfoRes?.cpcid])

    const getCpcInfo = async () => {

        const response = await tmdbApi.cpcInfo("ACTIVE,RESULT PENDING");
        
        if (response?.result === "Invalid token or Expired") {
             setShowSessionPopupup(true)
            // localStorage.clear();
            // navigate("/")
        } else
            if (response?.result?.length > 0) {
                 console.log('cpcInfoRes222 ', response?.result[0])
                //  setActiveTab("cpc")
                setCpcInfo(response?.result[0])
                localStorage.setItem('cpcid', response?.result[0]?.cpcid)
            }
    }

    console.log('cpcInfoRes ', cpcInfoRes)
    return (
        <>
            {showSessionPopupup && <SessionPopup />} 
            <div id="layout-wrapper">
                <Header />
             <SideMenu />

                <div className="main-content user-management cpc-manage" id="main-content">
                    <div className="page-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">
                            <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="breadcrumb-title">
                                                {/* {id === 'new' ? "New" : formData?.status} CPC */}
                                                CPC
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row table-data">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body cpc-management upcomingtable">
                                            <ul className="nav nav-tabs nav-tabs-custom mb-4" role="tablist">
                                                <li className="nav-item" role="presentation">
                                                    <button
                                                        className={`nav-link ${activeTab === "cpc" ? "active" : ""}`}
                                                        onClick={() => selectTab("cpc")}
                                                        role="tab"
                                                    >
                                                        <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                                        <span className="d-none d-sm-block">Active</span>
                                                    </button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button
                                                        className={`nav-link ${activeTab === "completed" ? "active" : ""}`}
                                                        onClick={() => selectTab("completed")}
                                                        role="tab"
                                                    >
                                                        <span className="d-block d-sm-none"><i className="far fa-user"></i></span>
                                                        <span className="d-none d-sm-block">Completed</span>
                                                    </button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button
                                                        className={`nav-link ${activeTab === "upcoming" ? "active" : ""}`}
                                                        onClick={() => selectTab("upcoming")}
                                                        role="tab"
                                                    >
                                                        <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                                        <span className="d-none d-sm-block">Upcoming</span>
                                                    </button>
                                                </li>
                                                {/* {completed && cpcInfoRes?.cpcid && */}
                                                {cpcInfoRes?.cpcid && 
                                                    <li className="nav-item" role="presentation">
                                                        <button
                                                            className={`nav-link ${activeTab === "activeresult" ? "active" : ""}`}
                                                            onClick={() => selectTab("activeresult")}
                                                            role="tab"
                                                        >
                                                            <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                                                            <span className="d-none d-sm-block">Announce Result</span>
                                                        </button>
                                                    </li>}
                                                    {/* } */}
                                            </ul>

                                            {activeTab === "cpc" && (
                                                <CPCForm setAnnounce={setAnnounce} cpcInfoRes={cpcInfoRes} />
                                            )}

                                            {activeTab === "completed" && 
                                                <Compeletedquiz setCompleted={setCompleted} restorePosition={restoreCompletedPage} />
                                            }

                                            {activeTab === "upcoming" &&
                                                <Upcomingquiz navigatePage={navigatePage} />
                                            }
                                            {activeTab === "activeresult" && 
                                            // {activeTab === "activeresult" && cpcInfoRes?.cpcid && 
                                                <ActiveResult navigatePage={navigatePage} setCompleted={setCompleted} cpcInfoRes={cpcInfoRes} />
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    );
};

export default Cpcmanagement;
